// TODO: Move from localStorage to Web Workers/Cookie-only approach

const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'cs_access_token'
const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'cs_refresh_token'
const LOCAL_STORAGE_REFRESHING_TOKEN_KEY = 'cs_refreshing_token'
const LOCAL_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY = 'cs_account_organization_ids'

export const getAccessTokenFromLocalStorage = (): string | null => localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)

export const getRefreshTokenFromLocalStorage = (): string | null =>
	localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)

export const getAccountOrganizationIdsFromLocalStorage = (): string | null =>
	localStorage.getItem(LOCAL_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY)

export const getIsRefreshingTokenFromLocalStorage = (): boolean | null => {
	const value = localStorage.getItem(LOCAL_STORAGE_REFRESHING_TOKEN_KEY)
	return value !== null ? value === 'true' : null
}

export const setAccessTokenInLocalStorage = (token: string): string | null => {
	try {
		localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, token)
		return token
	} catch (_err) {
		return null
	}
}

export const setRefreshTokenInLocalStorage = (token: string): string | null => {
	try {
		localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, token)
		return token
	} catch (_err) {
		return null
	}
}

export const setAccountOrganizationIdsInLocalStorage = (accountOrganizationIds: string): string | null => {
	try {
		localStorage.setItem(LOCAL_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY, accountOrganizationIds)
		return accountOrganizationIds
	} catch (_err) {
		return null
	}
}

export const setIsRefreshingTokenInLocalStorage = (isRefreshing: boolean): void => {
	localStorage.setItem(LOCAL_STORAGE_REFRESHING_TOKEN_KEY, isRefreshing.toString())
}

export const removeTokensFromLocalStorage = (): void => {
	localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)
	localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
	localStorage.removeItem(LOCAL_STORAGE_REFRESHING_TOKEN_KEY)
	localStorage.removeItem(LOCAL_STORAGE_ACCOUNT_ORGANIZATION_IDS_KEY)
}
